module.exports = __webpack_public_path__ + "static/media/eduPink.a0a9ad9f.svg";